import { texteEnLangue, type Langue } from '@artosera/shared';
import { useTranslation } from 'react-i18next';
import { useOeuvre, type OeuvrePresentee } from '../../api/oeuvres.js';
import { useExposition, type ExpositionPresentee } from '../../api/expositions.js';
import { useApercuMedia } from '../../api/medias.js';
import { ObjetCartel, proprietesCartel } from '../../composants/ObjetCartel.js';
import { VignetteOeuvre } from '../../composants/VignetteOeuvre.js';
import { useShellContext } from '../shell/context.js';
import styles from './NewsletterPage.module.css';
/** Les objets déjà composés restent nommés même s'ils sortent de la page des disponibles. */
export function CibleNewsletter({
  cible,
  oeuvre,
  exposition,
  url,
  langue,
  format,
}: {
  cible: { type: 'oeuvre' | 'exposition'; id: string };
  oeuvre?: OeuvrePresentee | null;
  exposition?: ExpositionPresentee | null;
  url?: string | null;
  langue: Langue;
  format?: 'carre' | 'vertical';
}) {
  const { galerieSlug } = useShellContext();
  const { t } = useTranslation('regie');
  const fiche = useOeuvre(galerieSlug, cible.type === 'oeuvre' && !oeuvre ? cible.id : null);
  const expo = useExposition(
    galerieSlug,
    cible.type === 'exposition' && !exposition ? cible.id : null,
  );
  const o = oeuvre ?? fiche.data?.oeuvre;
  const e = exposition ?? expo.data?.exposition;
  const apercu = useApercuMedia(galerieSlug, url ? null : (o?.mediaPrincipalId ?? null));
  const image = url ?? apercu.data ?? null;
  const cartel = o
    ? proprietesCartel(o, langue)
    : {
        titre: e
          ? texteEnLangue(e.titre, langue)
          : t(`newsletter.visuels.${cible.type === 'oeuvre' ? 'oeuvres' : 'expositions'}`),
      };
  return format ? (
    <>
      <div className={styles.visuel} style={{ aspectRatio: format === 'carre' ? '1' : '4 / 5' }}>
        <VignetteOeuvre taille="lg" className={styles.vignetteGrande} url={image} />
      </div>
      <ObjetCartel {...cartel} />
    </>
  ) : (
    <div className={styles.objet}>
      <VignetteOeuvre url={image} />
      <ObjetCartel {...cartel} />
    </div>
  );
}
